"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const DetailsRequests_1 = require("./Requests/DetailsRequests");
class UserRequests {
    constructor(session, username) {
        this.session = session;
        this.username = username;
    }
    getProfiles() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, { method: Paths_1.Methods.GET });
            const endpoint = `${this.session.baseUrl}/profiles?username=${this.username}`;
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    createProfile(name, meshRev) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof this.username === "undefined") {
                throw new Error("NO USERNAME SPECIFIFED, CANNOT CREATE PROFILE");
            }
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, {
                method: Paths_1.Methods.POST,
                body: {
                    name,
                    user_id: this.username,
                    icon: "installer-ignored",
                    mesh_api_rev: meshRev,
                },
            });
            return (0, Utils_1.wrapFetchJson)(request, `${this.session.baseUrl}/profiles`);
        });
    }
    getProfilesBySwitchSerial(serialNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, { method: Paths_1.Methods.GET });
            const endpoint = `${this.session.baseUrl}/profiles?switch_sn=${serialNumber}`;
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    inviteSelfToProfile(inviteURL) {
        return __awaiter(this, void 0, void 0, function* () {
            const inviteToken = UserRequests.findTheInviteCode(inviteURL);
            if (inviteToken === undefined) {
                throw new Error("Invite token not found in url");
            }
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, { method: Paths_1.Methods.GET });
            const endpoint = `${this.session.baseUrl}/invite?invite_token=${inviteToken}`;
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    static findTheInviteCode(longURL) {
        const urlEnd = longURL.split("?")[1];
        const paramStrings = urlEnd.split("&");
        for (const param of paramStrings) {
            if (param.startsWith("invite")) {
                return param.split("=")[1];
            }
        }
        return undefined;
    }
    user() {
        return new DetailsRequests_1.DetailsRequests(this.session, this.username);
    }
    setProfileFor3rdPartyIntegration(integration, profileUuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const integrationName = `${integration}_profile`;
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, {
                method: Paths_1.Methods.PUT,
                body: {
                    [integrationName]: profileUuid,
                },
            });
            const endpoint = `${this.session.baseUrl}/users/${this.username}`;
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
}
exports.UserRequests = UserRequests;
//# sourceMappingURL=UserRequests.js.map